export const extractUUIDFromString = (val: string): string => {
  try {
    return val?.match(/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/)?.[0] || "";
  } catch {
    return "";
  }
};
